import { createAction } from '@reduxjs/toolkit';
import {
  saveAccommodationSearchFormValues,
  saveAccommodationSearchResults,
  setAccommodationCurrentProvider,
  setAccommodationCurrentRoom,
  setAccommodationCurrentTotalPrice,
} from './accommodation_form';
import {
  saveJourneyFormValues,
  setJourneyDates,
  setJourneys,
  setSegmentStop,
} from './journey_form';
import { saveLuggageFormValues } from './luggage_form';
import { saveOptionalExtrasFormValues } from './optional_extras_form';
import { savePassengerFormValues } from './passenger_form';
import {
  saveOriginalServiceFormValues,
  saveServiceFormValues,
} from './service_form';
import { saveVehicleFormValues } from './vehicle_form';

const setMetaFlow = createAction('ui/sealink/setMetaFlow');
const setFerryGrouping = createAction('ui/sealink/setFerryGrouping');
const setBookingTenant = createAction('ui/sealink/setBookingTenant');
const saveCheckoutFormValues = createAction(
  'ui/sealink/journey/saveCheckoutFormValues'
);

export {
  setMetaFlow,
  setFerryGrouping,
  saveJourneyFormValues,
  setJourneyDates,
  setJourneys,
  setSegmentStop,
  savePassengerFormValues,
  saveLuggageFormValues,
  saveVehicleFormValues,
  saveServiceFormValues,
  saveOriginalServiceFormValues,
  saveAccommodationSearchFormValues,
  saveAccommodationSearchResults,
  setAccommodationCurrentProvider,
  setAccommodationCurrentRoom,
  setAccommodationCurrentTotalPrice,
  setBookingTenant,
  saveOptionalExtrasFormValues,
  saveCheckoutFormValues,
};
